// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loader-module__loader--37u-e{width:30px;height:30px;margin:20px auto;border:1px solid #fff;border:1px solid hsla(0,0%,100%,.2);border-top-color:#212121;border-radius:50%;animation:loader-module__loader-spin--3e4Hm 1s linear infinite}@keyframes loader-module__loader-spin--3e4Hm{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);
// Exports
exports.locals = {
	"loader": "loader-module__loader--37u-e",
	"loader-spin": "loader-module__loader-spin--3e4Hm"
};
module.exports = exports;
